import { getHeaders, sportProxy } from './proxies';
import { handleError, Result, success } from '../common/serviceUtil';
import { GetEventsResponse } from '../interfaces/sports';
import config from 'theme/config';

export const SportEndpoints = {
  GetEvents: '/events',
} as const;
type SportEndpointKey = keyof typeof SportEndpoints;
export type SportEndpoint = typeof SportEndpoints[SportEndpointKey];

interface GetEvents {
  eventGroupId?: number;
  eventIds?: number[];
  signal: AbortSignal | undefined;
  marketCode: string | undefined;
  languageCode: string | undefined;
}

export const getEvents = async ({
  eventGroupId,
  eventIds,
  signal,
  marketCode,
  languageCode,
}: GetEvents): Promise<Result<GetEventsResponse, unknown>> => {
  if (!eventGroupId && !eventIds) return fail('eventGroupId or eventIds required');
  try {
    const eventIdString = eventIds?.join('&eventId=') ?? undefined;
    const response = await sportProxy.get<GetEventsResponse>(
      `${SportEndpoints.GetEvents}?${eventIdString ? `eventId=${eventIdString}` : ''}`,
      {
        signal,
        params: {
          eventGroupId,
          marketCode: marketCode ?? 'OWIN',
          feedProvider: config.settings.feedProvider,
          languageCode,
        },
        headers: getHeaders(),
      },
    );
    return success(response.data);
  } catch (error) {
    return fail(handleError(error));
  }
};
